<div class="bpx-file-uploader bpx-uploader"
     [class.bpx-uploader--loaded]="selectedFiles.length > 0"
     dragAndDrop (fileDropped)="selectFiles($event)">

    <span class="material-icons bpx-uploader__icon" aria-hidden="true">cloud_upload</span>
    <p class="bpx-uploader__title" i18n>Drag and drop your files here</p>
    <p class="bpx-uploader__hint" i18n>or pick them from your computer</p>
    <form class="bpx-uploader__native" [formGroup]="fileSelectionForm">
        <input type="file" #fileSelector
               formControlName="file_selection"
               [accept]="config.mimeTypesAccepted"
               multiple="{{config.isMultipleSelectionAllowed}}">
    </form>
    <button matRipple
            type="button"
            class="file-upload__browse bpx-btn bpx-btn--primary"
            (click)="openFileSelector()" i18n>
        Browse Files
    </button>

    @if (selectedFiles.length) {
        <div class="bpx-uploader__list">
            <div class="bpx-uploader__list-head">
                <span class="bpx-uploader__count">
                    {{ selectedFiles.length }} {{ selectedFiles.length === 1 ? 'file' : 'files' }} selected
                </span>
                @if (selectedFiles.length > 1) {
                    <div class="bpx-uploader__bulk">
                        <button matRipple
                                type="button"
                                class="all_file__upload bpx-btn bpx-btn--primary"
                                aria-label="Upload All Files"
                                (click)="config.isReferenceFileUpload ? uploadAllReferenceFiles() : uploadAllInstrumentFiles()"
                                [disabled]="!isAnyFileNotUploaded() || (!config.isReferenceFileUpload && isAnyInstrumentUploadInProgress())">
                            <span aria-hidden="true" class="material-icons">file_upload</span>
                            <span i18n>Upload All</span>
                        </button>
                        <button *ngIf="!config.isReferenceFileUpload"
                                matRipple
                                type="button"
                                class="all_file__kitlots bpx-btn"
                                aria-label="Select Kit Lots"
                                (click)="requestKitLotDialog()">
                            <span aria-hidden="true" class="material-icons">tune</span>
                            <span i18n>Kit Lots</span>
                        </button>
                        <button matRipple
                                type="button"
                                class="all_file__cancel bpx-btn bpx-btn--danger"
                                aria-label="Cancel All Files"
                                (click)="initiateCancelAll()">
                            <span aria-hidden="true" class="material-icons">clear</span>
                            <span i18n>Cancel All</span>
                        </button>
                    </div>
                }
            </div>

            @for (selectedFile of selectedFiles; track selectedFile; let i = $index) {
                <div class="bpx-file-row"
                     [class.bpx-file-row--done]="selectedFile.uploadResult === 'success'"
                     [class.bpx-file-row--error]="!!selectedFile.uploadResult && selectedFile.uploadResult !== 'success'">
                    @if (selectedFile.uploadResult === 'success') {
                        <span class="material-icons bpx-file-row__glyph" aria-hidden="true">check_circle</span>
                    } @else if (!!selectedFile.uploadResult) {
                        <span class="material-icons bpx-file-row__glyph" aria-hidden="true">error_outline</span>
                    } @else {
                        <span class="material-icons bpx-file-row__glyph" aria-hidden="true">description</span>
                    }

                    <div class="bpx-file-row__body">
                        <div class="bpx-file-row__name" [title]="selectedFile.file.name">
                            {{ selectedFile.file.name }}
                        </div>
                        <div class="bpx-file-row__meta">
                            <span>{{ formatFileSize(selectedFile.file.size) }}</span>
                            @if (selectedFile.isUploadInProgress) {
                                <span class="bpx-file-row__sep" aria-hidden="true">&middot;</span>
                                <span i18n>Uploading&hellip;</span>
                            } @else if (selectedFile.uploadResult === 'success') {
                                <span class="bpx-file-row__sep" aria-hidden="true">&middot;</span>
                                <span class="bpx-file-row__status--done" i18n>Uploaded</span>
                            } @else if (!!selectedFile.uploadResult) {
                                <span class="bpx-file-row__sep" aria-hidden="true">&middot;</span>
                                <span class="bpx-file-row__status--error" role="alert">{{ selectedFile.uploadResult }}</span>
                            }
                        </div>
                    </div>

                    <div class="bpx-file-row__actions">
                        <button *ngIf="selectedFile.uploadResult !== 'success'"
                                matRipple
                                type="button"
                                class="selected_file__upload bpx-btn bpx-btn--icon bpx-file-row__upload"
                                matTooltip="Upload"
                                matTooltipPosition="left"
                                aria-label="Upload File"
                                (click)="config.isReferenceFileUpload ? uploadReferenceFile(i) : uploadInstrumentFile(i)"
                                [disabled]="selectedFile.isUploadInProgress || (!config.isReferenceFileUpload && isAnyInstrumentUploadInProgress())">
                            <span aria-hidden="true" class="material-icons">file_upload</span>
                        </button>
                        <button matRipple
                                type="button"
                                class="selected_file__cancel bpx-btn bpx-btn--icon bpx-btn--row-remove"
                                matTooltip="Remove"
                                matTooltipPosition="left"
                                aria-label="Cancel File"
                                (click)="inititateFileCancel(i)">
                            <span aria-hidden="true" class="material-icons">clear</span>
                        </button>
                    </div>

                    <mat-progress-bar *ngIf="selectedFile.isUploadInProgress"
                                      class="bpx-file-row__progress"
                                      mode="indeterminate"></mat-progress-bar>
                </div>
            }
        </div>
    }
</div>
